import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Plane, LineChart, Sprout, AlertTriangle, Search, CloudRain, Briefcase, BookOpen, FileBarChart } from 'lucide-react';
import { motion } from 'framer-motion';
const services = [{
  icon: Plane,
  title: 'Import & Export',
  desc: 'Permits & phytosanitary certs',
  link: '/import-export'
}, {
  icon: FileBarChart,
  title: 'Sector Statistics',
  desc: 'Agricultural data & reports',
  link: '/sector-statistics'
}, {
  icon: FileText,
  title: 'Guidelines & Services',
  desc: 'Center for all applications',
  link: '/guidelines-services'
}, {
  icon: CloudRain,
  title: 'Weather Advisory',
  desc: 'Current farming conditions',
  link: '/weather-advisory'
}, {
  icon: BookOpen,
  title: 'Library & Publications',
  desc: 'Access official documents',
  link: '/resources'
}, {
  icon: Briefcase,
  title: 'Opportunities',
  desc: 'Tenders & career openings',
  link: '/opportunities'
}];
const MotionLink = motion(Link);
export function QuickServices() {
  return <section className="py-12 bg-white relative z-20 -mt-10" data-id="element-415">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-416">
        <div className="bg-white rounded-xl shadow-xl shadow-gray-200/50 p-6 md:p-8 border border-gray-100" data-id="element-417">
          <h2 className="text-xl font-bold text-uganda-black mb-6" data-id="element-418">
            Quick Services
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6" data-id="element-419">
            {services.map((service, index) => {
            const Icon = service.icon;
            return <MotionLink to={service.link} key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="group flex flex-col items-center text-center p-4 rounded-lg hover:bg-uganda-light-green transition-colors border border-transparent hover:border-green-100" data-id="element-420">
                  <div className="w-12 h-12 rounded-full bg-green-50 text-uganda-green flex items-center justify-center mb-3 group-hover:bg-uganda-green group-hover:text-white transition-colors shadow-sm" data-id="element-421">
                    <Icon className="w-6 h-6" data-id="element-422" />
                  </div>
                  <h3 className="font-semibold text-sm text-uganda-black mb-1 group-hover:text-uganda-green transition-colors" data-id="element-423">
                    {service.title}
                  </h3>
                  <p className="text-xs text-gray-500" data-id="element-424">{service.desc}</p>
                </MotionLink>;
          })}
          </div>
        </div>
      </div>
    </section>;
}